import { authenticationService } from '@/api'

const currentUser = JSON.parse(localStorage.getItem('currentUser'))

export const auth = {
  namespaced: true,
  state: {
    status: {
      loggingIn: false,
      loggedIn: currentUser !== null
    },
    currentUser: currentUser
  },
  actions: {
    login ({
      dispatch,
      commit
    }, {
      email,
      password
    }) {
      commit('loginRequest', email)

      return new Promise((resolve, reject) => {
        authenticationService.login(email, password)
          .then((r) => {
            commit('loginSuccess', r.data)
            localStorage.setItem('currentUser', JSON.stringify(r.data))
            resolve()
          })
          .catch((err) => {
            commit('loginFailure', err)
            console.log(err)
            reject(err)
          })
      })
    },
    logout ({
      commit
    }) {
      localStorage.removeItem('currentUser')
      commit('logout')
    }
  },
  mutations: {
    loginRequest (state) {
      state.status.loggingIn = true
    },
    loginSuccess (state, user) {
      state.status.loggedIn = true
      state.status.loggingIn = false
      state.currentUser = user
    },
    loginFailure (state) {
      state.status.loggedIn = false
      state.status.loggingIn = false
      state.currentUser = null
    },
    logout (state) {
      state.status.loggedIn = false
      state.currentUser = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/auth/index.js